module.exports = {
          srcSet: __webpack_public_path__ + "4f1562afbf4effff00f647ec491e7807-90.png"+" 90w",
          images:[ {path: __webpack_public_path__ + "4f1562afbf4effff00f647ec491e7807-90.png",width: 90,height: 28}],
          src: __webpack_public_path__ + "4f1562afbf4effff00f647ec491e7807-90.png",
          toString:function(){return __webpack_public_path__ + "4f1562afbf4effff00f647ec491e7807-90.png"},
          
          width: 90,
          height: 28
        }